export var QuestionnaireEvaluationQuestionType;
(function (QuestionnaireEvaluationQuestionType) {
    QuestionnaireEvaluationQuestionType["FIRST"] = "first";
    QuestionnaireEvaluationQuestionType["NEXT"] = "next";
    QuestionnaireEvaluationQuestionType["PREVIOUS"] = "previous";
})(QuestionnaireEvaluationQuestionType || (QuestionnaireEvaluationQuestionType = {}));
//# sourceMappingURL=QuestionnaireEvaluationEnum.js.map